(ns app.domain.user.util
  (:require [clojure.string :as str]
            [core.user.model :as user-model]
            [core.util.string :as str-util]
            [potpuri.core :as p]))


(defn corporation-and-full-name-or-full-name [user]
  (let [user-name                  (user-model/full-name user)
        corporation-or-partnership (get user :user/corporation-or-partnership "")]
    (if-not (str/blank? user-name)
      (if-not (str/blank? corporation-or-partnership)
        (str corporation-or-partnership " (" user-name ")")
        user-name)
      corporation-or-partnership)))


(defn street-address+unit [user]
  (when-let [address (:user/street-address user)]
    (if-let [unit-number (:user/unit-number user)]
      (str address " " unit-number)
      address)))


(defn full-address [user]
  (if-some [address (street-address+unit user)]
    (if-some [municipality (:user/municipality user)]
      (str address " " municipality)
      address)
    (get user :user/municipality "")))


(defn municipality-province
  "Municipality, Province. Either/both can be missing. If both are missing, returns `nil`."
  [user]
  (->> [(:user/municipality user)
        (:user/province user)]
       (remove str/blank?)
       (str/join ", ")
       str-util/blank->nil))


(defn licence-number-for-type [user licence-type]
  (-> user
      :user/licences
      (p/find-first {:user-licence/type licence-type})
      :user-licence/number))
